<template>
  <v-navigation-drawer
    floating
    :value="isDrawerOpen"
    class="nav-drawer"
    app
    disable-route-watcher
    :permanent="$vuetify.breakpoint.lgAndUp"
    :mini-variant="$vuetify.breakpoint.lgAndUp && miniDrawer"
    mini-variant-width="60"
    @input="updateDrawerStatus"
    :width="$vuetify.breakpoint.lgAndUp ? 256 : 320"
  >
    <v-list
      class="nav-drawer-main"
      link
      nav
      dense
      :style="{
        'padding-left': $vuetify.breakpoint.mdAndDown ? '20px' : '8px',
        'padding-right': $vuetify.breakpoint.mdAndDown ? '20px' : '8px',
      }"
    >
      <v-list-item class="nav-drawer-collapse-container" :class="{ 'justify-end': $vuetify.breakpoint.lgAndUp }">
        <!-- for desktop navigation drawer: miniDrawer toggle -->
        <template v-if="$vuetify.breakpoint.lgAndUp">
          <v-btn v-if="!miniDrawer" icon @click.stop="toggleMiniDrawer(true)">
            <v-icon color="colorBlack" class="fi fi-rr-angle-square-left drawer-collapse-icon"></v-icon>
          </v-btn>
        </template>

        <!-- for mobile navigation drawer: close drawer -->
        <template v-else>
          <v-btn icon @click="updateDrawerStatus(false)">
            <v-icon color="colorBlack" class="fi fi-rr-cross-small"></v-icon>
          </v-btn>
        </template>
      </v-list-item>

      <!-- for desktop navigation drawer: miniDrawer toggle -->
      <v-list-item v-if="miniDrawer" @click.stop="toggleMiniDrawer(false)" class="mini-drawer-expand-icon">
        <v-list-item-icon>
          <v-icon class="fi fi-rr-angle-square-right"></v-icon>
        </v-list-item-icon>
        <v-list-item-content> </v-list-item-content>
      </v-list-item>

      <v-list-item-group color="primary" :class="{ 'mt-12': !miniDrawer }">
        <!-- for desktop and mobile navigation drawer -->
        <template v-if="!miniDrawer">
          <template v-for="(listItem, index) in drawerItemList">
            <NavListItemGroup :listItem="listItem" :index="index" @item-clicked="updateDrawerStatus($event)" />
          </template>
        </template>
        <!-- for desktop (mini) navigation drawer -->
        <template v-else>
          <template v-for="(listItem, index) in drawerItemList">
            <MiniNavListItemGroup :listItem="listItem" :index="index" @item-clicked="updateDrawerStatus($event)" />
          </template>
        </template>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import NavListItem from '@/components/NavDrawer/NavListItem.vue'
import NavListItemGroup from '@/components/NavDrawer/NavListItemGroup.vue'
import MiniNavListItemGroup from './MiniNavListItemGroup.vue'
export default {
  name: 'NavDrawer',
  components: {
    NavListItem,
    NavListItemGroup,
    MiniNavListItemGroup,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: false,
    },
    drawerItemList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    miniDrawer() {
      return this.$store.getters.miniDrawer
    },
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown
    },
  },
  data: () => ({
    showMiniLink: false,
  }),
  watch: {
    isMobile(val) {
      if (val && this.miniDrawer) {
        this.toggleMiniDrawer(false)
      }
    },
  },
  methods: {
    updateDrawerStatus(val) {
      this.$emit('update:isDrawerOpen', val)
    },
    toggleMiniDrawer(state) {
      if (this.miniDrawer === state) {
        return
      }

      this.$store.dispatch('setDrawer', state)
    },
  },
}
</script>
